import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { NOINDEX_PRIVATE_SEO } from "../../constants/siteSeo";
import { usePageSeo } from "../../hooks/usePageSeo";
import { useAuth } from "../../context/AuthContext";
import { SITE_DASHBOARD_PATH } from "../../constants/siteNavRoutes";
import AuthPageWalletSignIn from "./AuthPageWalletSignIn";
import "./auth-pages.css";

export default function LoginPage() {
  usePageSeo({
    ...NOINDEX_PRIVATE_SEO,
    title: "Sign in | Treydora",
    description: "Sign in to your Treydora account for dashboard and library access.",
  });

  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setBusy(true);
    try {
      await login(email.trim(), password);
      const from = location.state?.from;
      const fromPath = from && typeof from === "object" ? from.pathname : null;
      if (fromPath && fromPath !== "/login" && fromPath !== "/signup") {
        navigate(from, { replace: true });
      } else {
        navigate(SITE_DASHBOARD_PATH, { replace: true });
      }
    } catch (err) {
      setErrorMessage(err?.message || "Unable to log in right now.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="td-auth-page">
      <div className="td-auth-page__card">
        <p className="td-auth-page__brand">Treydora</p>
        <h1 className="td-auth-page__title">Sign in</h1>
        <p className="td-auth-page__lead">
          Enter the same email and password you use across Treydora. After signing in, use{" "}
          <strong style={{ color: "#e6cf8b" }}>Connect Wallet</strong> in the site header to sync NFT
          ownership and purchases to this account.
        </p>

        <form className="td-auth-page__form" onSubmit={onSubmit}>
          <input
            type="email"
            autoComplete="email"
            placeholder="Email"
            value={email}
            onChange={(ev) => setEmail(ev.target.value)}
            required
          />
          <input
            type="password"
            autoComplete="current-password"
            placeholder="Password"
            value={password}
            onChange={(ev) => setPassword(ev.target.value)}
            required
          />
          <div className="td-auth-page__actions">
            <button type="submit" className="oshar-btn-gold" style={{ width: "100%" }} disabled={busy}>
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </div>
        </form>

        {errorMessage ? <p className="td-auth-page__err">{errorMessage}</p> : null}

        <div className="td-auth-page__links">
          <Link to="/forgot-password">Forgot password</Link>
          <Link to="/signup">Create account</Link>
        </div>

        <div className="td-auth-page__divider">or</div>
        <AuthPageWalletSignIn />
      </div>
    </div>
  );
}
